import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getIsConfirmButton = (state: StateScheme) => {
    return state.updateDate.isNextButtonDisabled
}
